var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useContext } from 'react';
var NotificationContext = createContext({
    dynamicNotifications: [],
    addNotification: function () {
        console.warn('Tried to add a notification with no NotificationProvider');
    },
    clearNotifications: function () { }
});
export var useNotification = function () { return useContext(NotificationContext); };
/**
 * Controls adding and removing notifications that are dynamically added to the page through consuming apps
 */
export var NotificationProvider = function (_a) {
    var children = _a.children;
    var _b = useState([]), dynamicNotifications = _b[0], setDynamicNotifications = _b[1];
    var addNotification = function (notification) {
        setDynamicNotifications(function (prevDynamicNotifications) { return __spreadArray(__spreadArray([], prevDynamicNotifications, true), [
            notification
        ], false); });
    };
    var clearNotifications = function () { return setDynamicNotifications([]); };
    return (_jsx(NotificationContext.Provider, { value: { dynamicNotifications: dynamicNotifications, addNotification: addNotification, clearNotifications: clearNotifications }, children: children }));
};
